import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)

export const createRouter = () => {
    let router = new Router({
        mode: "history",
        fallback: false,
        scrollBehavior: () => ({ y: 0 }),
        routes: [
            { path: "/", component: () => import("../views/home.vue") },
            { path: "/authen/login", component: () => import("../views/authen/login.vue") },
            { path: "/authen/logout", component: () => import("../views/authen/logout.vue") },
            { path: "/authen/register", component: () => import("../views/authen/register.vue") },
            { path: "/authen/password/forgot", component: () => import("../views/password/password.forgot.vue") },
            { path: "/project/list", component: () => import("../views/project/project.list.vue") },
            { path: "/project/detail/:id", component: () => import("../views/project/project.detail.vue") },
            { path: "/link/ranking/:id", component: () => import("../views/link/ranking/link.ranking.list.vue") },
            { path: "/tool/stock/scan", component: () => import("../views/tool/stock/tool.stock.scan.vue") },
            { path: "/tool/file/metadata", component: () => import("../views/tool/file/tool.file.metadata.vue") },
            { path: "/tool/qrcode/create", component: () => import("../views/tool/qrcode/qrcode.create.vue") },
        ],
    });

    return router;
};



// WEBPACK FOOTER //
// src/router/index.js